import { Pipe, PipeTransform } from '@angular/core';
import { CaseAcquisitionStatus } from '../../../service/cases.service';

@Pipe({
  name: 'leadStatus',
  pure: true,
})
export class LeadStatusPipe implements PipeTransform {
  private readonly statusLabel: Record<CaseAcquisitionStatus, string> = {
    [CaseAcquisitionStatus.HISTORY]: 'Antigos',
    [CaseAcquisitionStatus.LEAD]: 'Leads',
    [CaseAcquisitionStatus.CONTACTED_LEAD]: 'Lead Contactados',
    [CaseAcquisitionStatus.CLIENT]: 'Virou Cliente',
    [CaseAcquisitionStatus.LOST_LEAD]: 'Lead Perdido',
    [CaseAcquisitionStatus.PROCESS_COMPLETED_SUCCESS]: 'Processo Finalizado com Sucesso',
    [CaseAcquisitionStatus.PROCESS_COMPLETED_FAILURE]: 'Processo Finalizado sem Sucesso',
  };

  transform(value: CaseAcquisitionStatus | null | undefined): string {
    if (value == null) return '';
    return this.statusLabel[value] ?? String(value);
  }
}
